(() => {
  if (window.__eleatPlanCtaInitialised || new URLSearchParams(window.location.search).get('eleat_cta_control') === '1') return;
  window.__eleatPlanCtaInitialised = true;
  const controllers = new Map();
  const propertyNames = ['--eleat-cta-card-top', '--eleat-cta-card-left', '--eleat-cta-card-width'];
  const initialise = scope => {
    const plans = Array.from(scope.querySelectorAll('.product-template__plan'));
    if (scope.matches?.('.product-template__plan')) plans.unshift(scope);
    plans.forEach(plan => {
      if (controllers.has(plan)) return;
      const button = plan.querySelector('.product-template__plan-cta');
      if (!button) return;
      const slot = document.createElement('div');
      slot.className = 'eleat-plan-cta-slot';
      slot.setAttribute('aria-hidden', 'true');
      const purchase = plan.closest('.component-product-info-alt');
      let frame = 0;
      let disposed = false;
      const setProperty = (name, value) => {
        if (plan.style.getPropertyValue(name) !== value) plan.style.setProperty(name, value);
      };
      const schedule = () => {
        if (disposed || frame) return;
        frame = requestAnimationFrame(position);
      };
      function positionNow() {
        if (disposed) return;
        if (frame) {
          cancelAnimationFrame(frame);
          frame = 0;
        }
        position();
      }
      function reset() {
        if (plan.classList.contains('eleat-cta-in-card')) plan.classList.remove('eleat-cta-in-card');
        slot.remove();
        propertyNames.forEach(name => { if (plan.style.getPropertyValue(name)) plan.style.removeProperty(name); });
      }
      function position() {
        frame = 0;
        if (disposed) return;
        if (!plan.isConnected) { destroy(); return; }
        if (!plan.getClientRects().length) return;
        const card = plan.querySelector('.product-template__plan-option.active');
        const expanded = card?.querySelector('.plan-option__expanded');
        if (!expanded) { reset(); return; }
        if (slot.parentElement !== expanded) expanded.appendChild(slot);
        const height = Math.ceil(button.getBoundingClientRect().height);
        if (height < 1) return;
        const heightValue = `${height}px`;
        if (slot.style.height !== heightValue) slot.style.height = heightValue;
        const area = plan.getBoundingClientRect();
        const target = slot.getBoundingClientRect();
        if (target.width < 1) return;
        setProperty('--eleat-cta-card-top', `${target.top - area.top - plan.clientTop + plan.scrollTop}px`);
        setProperty('--eleat-cta-card-left', `${target.left - area.left - plan.clientLeft + plan.scrollLeft}px`);
        setProperty('--eleat-cta-card-width', `${target.width}px`);
        if (!plan.classList.contains('eleat-cta-in-card')) plan.classList.add('eleat-cta-in-card');
      }
      const mutations = new MutationObserver(records => {
        if (records.some(record => record.target === plan || record.target.matches?.('.product-template__plan-option'))) positionNow();
      });
      mutations.observe(plan, {attributes: true, subtree: true, attributeFilter: ['class']});
      const resize = new ResizeObserver(schedule);
      resize.observe(plan);
      resize.observe(button);
      const onPlanClick = event => {
        const card = event.target.closest?.('.product-template__plan-option');
        if (card && plan.contains(card)) positionNow();
      };
      let planEventPending = false;
      const onPlanEvent = () => {
        if (planEventPending) return;
        planEventPending = true;
        queueMicrotask(() => { planEventPending = false; positionNow(); });
      };
      plan.addEventListener('click', onPlanClick);
      window.addEventListener('resize', schedule, {passive: true});
      window.addEventListener('pageshow', schedule);
      purchase?.addEventListener('product-info-alt:set-plan', onPlanEvent, true);
      purchase?.addEventListener('eleat:product-ready', positionNow);
      document.fonts?.ready.then(schedule);
      function destroy() {
        if (disposed) return;
        disposed = true;
        mutations.disconnect();
        resize.disconnect();
        cancelAnimationFrame(frame);
        plan.removeEventListener('click', onPlanClick);
        window.removeEventListener('resize', schedule);
        window.removeEventListener('pageshow', schedule);
        purchase?.removeEventListener('product-info-alt:set-plan', onPlanEvent, true);
        purchase?.removeEventListener('eleat:product-ready', positionNow);
        reset();
        controllers.delete(plan);
      }
      controllers.set(plan, {destroy});
      positionNow();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(document), {once: true});
  else initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((controller, plan) => { if (event.target.contains(plan)) controller.destroy(); });
  });
})();
